<template>
    <div class="tm-container flex space-evenly vertical-center">
        <div class="tm-member-container md-container">
            <div class="tm-member" v-for="member in members" :key="member.id">
                <img :src="member.img" alt="">
                <p class="tm-member-name">{{member.name}}</p>
            </div>
        </div>
        <div class="tm-content-container">
            <img class="page-num" :src="require('../../assets/Mobile/Mobile_Landing/04-img.svg')" alt="Page 4">
            <h1 class="tm-title" style="cursor:pointer;" @click="team_route()">Our Team</h1>
            <img class="mobile-team" :src="require('../../assets/Desktop/Home_Landing/Mike_Pratt_IMG.png')" alt="Mobile Team Member">
            <p class="tm-text">Be the first to sign up for the beta and earn VIP access for life. Why not be apart of a platform that turns dreams into reality.</p>
        </div>
        <re-panel-nav style="width: 180px;" class="flex right lg-container"></re-panel-nav>
    </div>
</template>

<script>
    import Panel_Nav from './Panel_Nav.vue'

    export default {
        data () {
            return {
                members: [
                    {'name': '', 'img': require('../../assets/Desktop/Home_Landing/Mike_Pratt_IMG.png')},
                    {'name': '', 'img': require('../../assets/Desktop/Home_Landing/Elias_Hammet_IMG.png')},
                    {'name': '', 'img': require('../../assets/Desktop/Home_Landing/AR_IMG.png')},
                    {'name': '', 'img': require('../../assets/Desktop/Home_Landing/DR_IMG.png')}
                ]
            }
        },
        mounted: function() {
            let nav_location = document.querySelectorAll('.tm-container')[0].querySelectorAll('.ot-item')[0]
            nav_location.style['font-size'] = '15px';
            nav_location.style['color'] = '#DAAE3E';
        },
        components: {
            're-panel-nav': Panel_Nav
        },
        methods: {
            team_route: function(e) {
                this.$router.push({'name': 'Team'})
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .tm-container {
            height: 1000px;
            background-image: url(../../assets/Mobile/Mobile_Landing/our_team_bg.jpg) !important;
            background-position: center !important; /* Center the image */
            background-repeat: no-repeat !important; /* Do not repeat the image */
            background-size: 100% 100% !important;
        }

        .tm-text, .tm-title {
            text-align: center !important;
            margin: 35px 0 !important;
        }

        .tm-content-container {
            display: flex !important;
            justify-content: center!important;
            flex-direction: column !important;
        }

        .page-num {
            display: block !important;
            margin: 80px 0 0 0 !important;
        }

        .mobile-team {
            display: block !important;
            width: auto !important;
            height: 415px !important;
        }
    }

    .page-num, .mobile-team {
        display: none;
    }

    .tm-container {
        height: 810px;
        background-image: url(../../assets/Desktop/Home_Landing/Our_Team_BG_IMG.jpg);
        overflow: hidden;
    }

    .tm-title {
        color: #FFFFFF;	font-family: Trirong;	
        font-size: 32px;	
        font-weight: 800;	
        line-height: 44px;
    }

    .tm-text {
        color: #FFFFFF;	font-family: Trirong;	
        font-size: 15px;	
        letter-spacing: 1px;	
        line-height: 28px;
        width: 331px;
        font-weight: 400;
    }

    .tm-member {
        height: 294px;
        width: 252px;
    }

    .tm-member-container {
        display: flex;
        flex-wrap: wrap;
        width: 505px;
    }

    .tm-member-name {
        position: relative;
        top: -22%;
        left: 11%;
        color: #FFFFFF;
        font-family: Oswald;
        font-size: 13px;
        font-weight: 400;
        letter-spacing: 3.86px;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/Our_Team.vue